import React, { useEffect, useState } from "react";
import RoleDetail from "../modals/roles/RoleDetail";
import PaginationLinks from "../pagination/PaginationLinks";
import { BounceLoader } from "react-spinners";
import { useSelector } from "react-redux";

const RolesTable = ({ roles, fetchRolesHandler }) => {
  const [hasViewRole, setHasViewRole] = useState();

  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { isLoading, searchLoading } = useSelector((state) => state?.role);
  const [singleItem, setSingleItem] = useState({});

  useEffect(() => {
    setHasViewRole(
      user_permissions?.some(
        (permission) => permission.name === "view role details"
      )
    );
  }, [user_permissions]);

  if (isLoading) {
    return (
      <div className='d-flex mt-lg-5 justify-content-center align-content-center'>
        <BounceLoader color='#2E3192' size={"70px"} />
      </div>
    );
  }
  return (
    <>
      {roles?.data?.length < 1 ? (
        <h5 className='alert alert-info mt-3'>Result not found!</h5>
      ) : (
        <div className=''>
          <div className='table-responsive mt-3 '>
            <table className='table table-centered table-striped no-footer'>
              <thead>
                <tr>
                  <th
                    className='sorting'
                    tabIndex='0'
                    rowSpan='1'
                    colSpan='1'
                    style={{ width: "100.8px" }}
                    aria-label='Customer: activate to sort column ascending'
                  >
                    Name
                  </th>
                  <th
                    className='sorting'
                    tabIndex='0'
                    rowSpan='1'
                    colSpan='1'
                    style={{ width: "144.8px" }}
                    aria-label='Phone: activate to sort column ascending'
                  >
                    Description
                  </th>
                  <th
                    className='sorting'
                    tabIndex='0'
                    rowSpan='1'
                    colSpan='1'
                    style={{ width: "100.8px" }}
                    aria-label='Email: activate to sort column ascending'
                  >
                    Status
                  </th>
                  {hasViewRole && (
                    <th style={{ width: "85.8px" }} className='text-center'>
                      Action
                    </th>
                  )}
                </tr>
              </thead>

              {roles?.data?.length ? (
                <>
                  <tbody>
                    {roles?.data?.map((item, i) => (
                      <tr key={i}>
                        <td className='text-capitalize'>{item?.name}</td>
                        <td className='text-capitalize'>{item?.description}</td>
                        <td>
                          <span
                            className={`badge badge-${
                              item?.active === "0" ? "danger" : "success"
                            }-lighten fw-normal rounded-4`}
                            style={{
                              fontSize: "10px",
                              padding: "5px 18px",
                            }}
                          >
                            {item?.active === "0" ? "disabled" : "active"}
                          </span>
                        </td>
                        {hasViewRole && (
                          <td className='p-0 text-center'>
                            <span
                              onClick={() => setSingleItem(item)}
                              data-bs-toggle='modal'
                              data-bs-target='#staticBackdrop1'
                            >
                              <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                            </span>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </>
              ) : (
                ""
              )}
            </table>

            {searchLoading && (
              <div
                className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                style={{ height: "100%" }}
              >
                <div className='mx-auto'>
                  <BounceLoader
                    color='#090b8f'
                    loading={true}
                    // cssOverride={override}
                    size={50}
                    aria-label='Loading Spinner'
                    data-testid='loader'
                    className='ms-3'
                  />
                  <span className='fw-bolder text-primary-1 ms-2'>
                    Please wait...
                  </span>
                </div>
              </div>
            )}
          </div>

          <RoleDetail modal_id='staticBackdrop1' item={singleItem} />

          {roles?.data?.length ? (
            <div className='row mt-4'>
              <div className='col-sm-12 col-md-6'>
                <div
                  className='dataTables_info table-pages'
                  id='products-datatable_info'
                  role='status'
                  aria-live='polite'
                >
                  Showing offices {roles?.from} to {roles?.to} of {roles?.total}
                </div>
              </div>

              <div className='col-sm-12 col-md-6'>
                <PaginationLinks
                  paginationData={roles}
                  getNextPage={fetchRolesHandler}
                />
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default RolesTable;
